import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Loader from '../Loader/Loader';
import './Facility.css'
import FacilityCard from './FacilityCard'

const FACILITIES_URL = '/facilities'

function Facility() {
    const [facilities, setFacilities] = useState([])
    const [sortedFacilities, setSortedFacilities] = useState([])

    useEffect(() => {
        async function getFacilities() {
            try {
                const response = await axios.get(process.env.REACT_APP_DEPT_API + FACILITIES_URL);
                setFacilities(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        getFacilities()
    }, [])

    useEffect(() => {
        let sorted = facilities && facilities.sort((a, b) => a.order_no < b.order_no ? -1 : 1)
        setSortedFacilities(sorted)
    }, [facilities])

    return (
        <div className='facility'>
            <div className='section__container'>
                <div className='section'>
                    <h1 className='section__header'>Facilities</h1>
                    <p className='about__p'>The Department has excellent infrastructural facilities and well-maintained laboratories. There are over 150 computers in three laboratories with ample processing power running Debian GNU/Linux and Windows in addition to an Apple iMac 27” Desktop Computer and an Nvidia Quattro based workstation. </p>
                    <div className='facility_container'>
                        {sortedFacilities ? sortedFacilities.map(fac => (
                            <FacilityCard
                                key={fac._id}
                                title={fac.title}
                                description={fac.description}
                                order_no={fac.order_no}
                                image={fac.image && fac.image.url}
                            />
                        )) : <Loader color="#AE9142" size={80} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Facility